import { Link } from 'react-router-dom'
import { TrendingUp, Mail, Twitter } from 'lucide-react'
import { useLanguage } from '@/contexts/LanguageContext'
import { CONTACT } from '@lib/constants'
import { CheckerAccent } from '@components/shared/CheckerAccent'

export function Footer() {
  const { t } = useLanguage()
  const currentYear = new Date().getFullYear()

  const footerLinks = {
    product: [
      { labelKey: 'footer.product.features', href: '/#features' },
      { labelKey: 'footer.product.pricing', href: '/pricing' },
      { labelKey: 'footer.product.howItWorks', href: '/how-it-works' },
      { labelKey: 'footer.product.faq', href: '/faq' },
    ],
    company: [
      { labelKey: 'footer.company.about', href: '/about' },
      { labelKey: 'footer.company.affiliate', href: '/affiliate' },
      { labelKey: 'footer.company.contact', href: '/contact' },
    ],
    legal: [
      { labelKey: 'footer.legal.terms', href: '/legal/terms' },
      { labelKey: 'footer.legal.privacy', href: '/legal/privacy' },
      { labelKey: 'footer.legal.cookies', href: '/legal/cookies' },
    ],
  }

  const columns: [string, { labelKey: string; href: string }[]][] = [
    ['footer.product', footerLinks.product],
    ['footer.company', footerLinks.company],
    ['footer.legal', footerLinks.legal],
  ]

  return (
    <footer className="bg-black text-white border-t border-white/10">
      {/* Bande damier en séparateur haut */}
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="py-4 flex gap-1.5">
          {Array.from({ length: 8 }).map((_, i) => (
            <CheckerAccent key={i} className="text-white/15" />
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 pb-16 pt-8 border-t border-white/10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1">
            <Link to="/" className="flex items-center gap-3 group mb-5">
              <div className="w-10 h-10 bg-chrome flex items-center justify-center group-hover:scale-105 transition-transform">
                <TrendingUp className="h-5 w-5 text-black" />
              </div>
              <span className="text-xl font-head font-bold tracking-tight">TrackMarkete</span>
            </Link>
            <p className="text-neutral-400 text-sm leading-relaxed max-w-xs">
              {t('footer.description')}
            </p>
          </div>

          {columns.map(([titleKey, links]) => (
            <div key={titleKey}>
              <h3 className="label text-neutral-500 mb-5">{t(titleKey)}</h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.href}>
                    <Link to={link.href} className="text-sm text-neutral-400 hover:text-white transition-colors">
                      {t(link.labelKey)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="label !text-[10px] text-neutral-500">
            © {currentYear} TrackMarkete. {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-3">
            <a href={`mailto:${CONTACT.EMAIL}`} className="w-9 h-9 flex items-center justify-center border border-white/15 text-neutral-400 hover:text-white hover:border-white/40 transition-colors" aria-label="Email">
              <Mail size={16} />
            </a>
            <a href={CONTACT.TWITTER} target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center border border-white/15 text-neutral-400 hover:text-white hover:border-white/40 transition-colors" aria-label="Twitter">
              <Twitter size={16} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
